<template>
  <div class="jobDetail browseCourses jobSearch breadcrumbs-absolute Regular"  @click="closeSelectList" style="overflow:inherit" >
    <Breadcrumbs></Breadcrumbs>
    <BrowseCoursesSearch
      v-bind:childLogGaEvent="childLogGaEvent"
      v-bind:needOptions="true"
      v-bind:search="search"
      v-bind:filterActive="filterActive"
      ref="browseC"
    ></BrowseCoursesSearch>
    <div ref="courseList" class="opp-contain row" style="background-color:#fff;">
      <div
        class="description opportunityPC coursesList col-sm-10 col-md-8 padLeft-0 padRight-0"
        :class="{'coursesListPC':$store.state.innerWidth>768}"
      >
        <div class="pad-15 row courseTotal">
          <div>
            <span  v-if="aok.length>0">{{totalRows}} {{$t('message.results')}}</span>
            <span
              v-if="(coursesType==1||coursesType==2)&&aok.length>0"
            >{{$t('message.for')}}{{$store.getters.getContent(occupationDetail.title)}}{{$t('message.forEnd')}}</span>
            <span
              v-if="(coursesType==3||coursesType==4)&&aok.length>0"
            >{{$t('message.for')}}{{$store.getters.getObject(course.langMap).title}}{{$t('message.forEnd')}}</span>
            <div class="there-are" v-if="aok.length==0">
              {{$t('message.There are no')}}
            </div>
          </div>
        </div>
        <div class="pad-5 row" :class="{'margin-20':$store.state.innerWidth>768}">
          <div
            class="col-xs-6 col-sm-4 col-md-4 col-lg-3 pad-5 pointer"
            :class="{'pad-33':$store.state.innerWidth>768}"
             v-for="(course,index) in aok"
            v-if="numberBars>index&&index>=(numberBars-20)"
            v-on:click="toCoursesDetails(course)"
          > 
            <a class="displayA" v-bind:href='"/coursesDetail/" + course.dataSource + "/" + encodeEvent(course.key)+"?lang="+$store.state.language+"&name="+$store.getters.replaceEvent($store.getters.getObject(course.langMap).title)'></a>
            <div class="couses-item">
              <div class="min-height">
                <div>
                  <span
                    class="timeTip SemiBold"
                    v-if="$store.getters.getTrim(mode)=='FT'||$store.getters.getTrim(mode)=='PT'||$store.getters.getTrim(mode)=='DL'||$store.getters.getTrim(mode)=='EL'"
                    v-for="mode in course.learningMode"
                  >{{$t('message.'+$store.getters.getTrim(mode)+'')}}</span>
                  <span class="timeTip SemiBold" v-if="course.isCef">CEF</span>
                </div>
                <div class>
                  <a href="javascript:;" style="color: inherit">
                    <h4 class="SemiBold courseTitle fourline-box">{{$store.getters.getObject(course.langMap).title}}</h4>
                  </a>
                  <div>
                    <p class="twoline-box">{{$store.getters.getObject(course.langMap).grantingBody[0]}}</p>
                  </div>
                </div>
              </div>
              <span class="hotPicks">
                <i class="icon-hot" v-if="course.isHotpick" style="padding: 0 15px 0 0;"></i>
                <span class="Medium" v-if="course.isHotpick">{{$t('message.hotPicks')}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="center row" data-load="loading" :class="{'opacity0':!isLoading}">
          <span class="user-writing">
            <span></span>
          </span>
        </div>
      </div>
    </div>
    <Paging v-on:changeRow="changeStartRow" v-on:changePaging="changeSmallPaging" :courseListAll="aok" :toRows="totalRows" ref="Pa" ></Paging>
    <div class="opp-contain opp-contain-coursesJia">
      <div class="browseCourses-bottom opportunityPC ">
        <div class="powered-by powered-by-browseCourses Bold">
            {{$t('message.Powered by')}} 
        </div>
        <div class="browseCourses-bottom-imgPlace">
          <div class="qr">
            <a href="https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-en/" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="qrEnTc" alt="hkqr.gov.hk Logo"></a>
            <a href="https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-tc/index.html" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="qrEnTc" alt="hkqr.gov.hk 標誌"></a>
            <a href="https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-sc/index.html" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="qrSc" alt="hkqr.gov.hk 标志"></a>
          </div>
          <div class="edx">
            <a href="https://www.edx.org" target="_blank" ><img :src="edx" alt="edx Logo"></a>
          </div>
          <div class="microsoft">
            <a href="https://docs.microsoft.com/en-gb/learn/" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="microsoft" alt="hkqr.gov.hk Logo"></a>
            <a href="https://docs.microsoft.com/zh-hk/learn/" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="microsoft" alt="hkqr.gov.hk 標誌"></a>
            <a href="https://docs.microsoft.com/zh-cn/learn/" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="microsoft" alt="hkqr.gov.hk 标志"></a>
          </div>
        </div>
      </div>
     
    </div>
  
     <a v-if="(startRow*5+smallPaging)<(totalRows/20+1)" class="displayA" v-bind:href="'./browseCourses'+'?lang='+$store.state.language+'&page='+(startRow*5+smallPaging+1)"></a>
    <!-- <a v-if="(startRow*5+smallPaging)>0" class="displayA" v-bind:href="'./browseCourses'+'?lang='+$store.state.language+'&page='+(startRow*5+smallPaging-1)"></a> -->
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import BrowseCoursesSearch from "@/components/BrowseCoursesSearch";
import Swiper from "@/components/Swiper.vue";
import MessageLoading from "@/components/MessageLoading";
import { EventBus } from "@/javascripts/eventBus.js";
import Paging from "@/components/paging.vue";
import qrEnTc from '../images/QR_en_tc.jpg';
import qrSc from '../images/QR_sc.jpg';
import edx from '../images/edx-logo-registered.png';
import microsoft from '../images/Microsoft-logo_rgb_c-gray.png';

export default {
  name:"BrowseCourses",
  data() {
    return {
      courses: [],
      filter: {},
      startRow: 0,
      maxRows: 20,
      dataSource: "",
      isCef: "",
      keyword: "",
      learningMode: "",
      areaOfStudy: "",
      grantingBody: "",
      courseQuickQuery: "",
      isLoading: false,
      loadEnd: false,
      totalRows: 0,
      coursesType: 0,
      occupationId: 0,
      occupationDetail: {},
      courseKey: "",
      course: {},
      aok: [],
      smallPaging: 1,
      numberBars: 20,
      qrEnTc:qrEnTc,
      qrSc:qrSc,
      edx:edx,
      microsoft:microsoft,
      scroll:0,
      fromLouterName:'',
      filterActive: {
        filter: "",
      },
    }
  },   
  props: ["logGaEvent"],
  components: {
    Breadcrumbs,
    Swiper,
    BrowseCoursesSearch,
    MessageLoading,
    Paging
  },
  created() {


    
  },
  methods: {
   
    handleScroll () {
        this.scroll  = document.documentElement.scrollTop||document.body.scrollTop;
        
    },
    closeSelectList:function(){
      if(this.$refs.Pa !=undefined){
         this.$refs.Pa.closeSelecPagingList();
      }
     
    },
    changeSmallPaging: function(val) {
      var that = this;
      this.smallPaging = val;
      window.scrollTo(0, that.$refs.courseList.offsetTop);
      if (this.smallPaging == 1) {
        this.numberBars = 20;
      } else if (this.smallPaging == 2) {
        this.numberBars = 40;
      } else if (this.smallPaging == 3) {
        this.numberBars = 60;
      } else if (this.smallPaging == 4) {
        this.numberBars = 80;
      } else if (this.smallPaging == 5) {
        this.numberBars = 100;
      }
      
    },
    changeStartRow: function(val) {
      console.log(val)
      this.startRow = val;
      this.getCourseList({
        "dataSource":this.dataSource,
        "isCef":this.isCef,
        "keyword":this.keyword,
        "learningMode":this.learningMode,
        "areaOfStudy":this.areaOfStudy,
        "grantingBody":this.grantingBody,
        "courseQuickQuery":this.courseQuickQuery,
      });
       
    },
    childLogGaEvent: function(eventCategory,eventAction,eventLabel,eventValue) {
      this.logGaEvent(eventCategory, eventAction, eventLabel, eventValue);
    },
    encodeEvent:function(key){
      return encodeURIComponent(key)
    },
    toCoursesDetails: function(course) {
      let key = "";
      // if (course.dataSource == 'edx') {
      key = encodeURIComponent(course.key);
      // } else {
      //     key = course.id
      // }
      setTimeout(()=>{
          this.logGaEvent('userClick','goCoursesDetail',course.dataSource + "/" + key)
          this.$router.push({path:"/coursesDetail/" + course.dataSource + "/" + key, query:{lang:this.$store.state.language,name:this.$store.getters.replaceEvent(this.$store.getters.getObject(course.langMap).title)}});
          window.scrollTo(0,0)
      },100)
    },
    search: function(obj) {
      this.startRow = 0;
      this.courses = [];
      this.dataSource = obj.dataSource;
      this.isCef = obj.isCef;

      this.keyword = obj.keyword;
      this.learningMode = obj.learningMode;
      this.areaOfStudy = obj.areaOfStudy;
      this.grantingBody = obj.grantingBody;
      this.courseQuickQuery = obj.courseQuickQuery;
      this.coursesType = 0;
      this.getCourseList(obj);
      if(this.$refs.Pa != undefined){
        if(!that.$route.query.page){
          this.$refs.Pa.changePageOne();
        }
        this.$refs.Pa.closeSelecPagingList();
      }
    },
    getCourseList: function(obj) {
      if (!obj) {
        obj = {};
      }
      if (this.isLoading) return;
      obj.startRow = this.startRow;
      obj.maxRows = this.maxRows;
      let that = this;
      that.isLoading = true;
      this.api.getCourseList(
        obj,
        function(data) {
        //   that.startRow++;
          that.isLoading = false;
          that.totalRows = data.result.totalRows;
          let courses = data.result.result;
          that.courses = [];
          that.aok = data.result.result;
          for (let i = 0; i < courses.length; i++) {
            if (courses[i].learningMode) {
              courses[i].learningMode = courses[i].learningMode.split(",");
            }
            that.courses.push(courses[i]);
          }
          if (that.courses.length >= that.totalRows) {
            that.loadEnd = true;
          }
           
        },
        function() {
          that.isLoading = false;
        }
      );
    },
    getAllDetailLinkCourse: function(obj) {
      if (!obj) {
        obj = {};
      }
      if (this.isLoading) return;
      obj.startRow = this.startRow;
      obj.maxRows = this.maxRows;
      obj.key = this.courseKey;
      if (this.coursesType == 3) {
        obj.dataSource = "qr";
      } else if (this.coursesType == 4) {
        obj.dataSource = "edx";
      }
      let that = this;
      that.isLoading = true;
      this.api.getAllDetailLinkCourse(
        obj,
        function(data) {
          //
          that.isLoading = false;
          that.totalRows = data.result.totalRows;
          let courses = data.result.result;
          for (let i = 0; i < courses.length; i++) {
            if (courses[i].learningMode) {
              courses[i].learningMode = courses[i].learningMode.split(",");
            }
            that.courses.push(courses[i]);
          }
          if (that.courses.length >= that.totalRows) {
            that.loadEnd = true;
          }
          // if (that.startRow == 0) {
          //   setTimeout(function() {
          //     window.scrollTo(0, that.$refs.courseList.offsetTop);
          //   });
          // }
        //   that.startRow++;
        },
        function() {
          that.isLoading = false;
        }
      );
    },
    getListAllByOccupation: function(obj) {
      if (!obj) {
        obj = {};
      }
      if (this.isLoading) return;
      obj.startRow = this.startRow;
      obj.maxRows = this.maxRows;
      obj.occupationId = this.occupationId;
      if (this.coursesType == 1) {
        obj.dataSource = "qr";
      } else if (this.coursesType == 2) {
        obj.dataSource = "edx";
      }
      let that = this;
      that.isLoading = true;
      this.api.getListAllByOccupation(
        obj,
        function(data) {
          //
          that.isLoading = false;
          that.totalRows = data.result.totalRows;
          let courses = data.result.result;
          for (let i = 0; i < courses.length; i++) {
            if (courses[i].learningMode) {
              courses[i].learningMode = courses[i].learningMode.split(",");
            }
            that.courses.push(courses[i]);
          }
          if (that.courses.length >= that.totalRows) {
            that.loadEnd = true;
          }
          // if(that.startRow==0){
          //     setTimeout(function(){
          //         window.scrollTo(0,that.$refs.courseList.offsetTop);
          //     })
          // }
        //   that.startRow++;
        },
        function() {
          that.isLoading = false;
        }
      );
    },
    // scrollEvent: function() {
    //   var that = this;
    //   var e = document.querySelectorAll("[data-load]");
    //   if (e.length == 0) return;
    //   if (
    //     e[0].offsetTop - window.scrollY < window.innerHeight - 750 &&
    //     !that.isLoading &&
    //     !that.loadEnd
    //   ) {
    //     if (this.coursesType == 1 || this.coursesType == 2) {
    //       this.getListAllByOccupation();
    //     } else if (this.coursesType == 3 || this.coursesType == 4) {
    //       this.getAllDetailLinkCourse();
    //     } else {
    //       that.getCourseList({
    //         dataSource: that.dataSource,
    //         isCef: that.isCef,
    //         keyword: that.keyword,
    //         learningMode: that.learningMode,
    //         areaOfStudy: that.areaOfStudy,
    //         grantingBody: that.grantingBody
    //       });
    //     }
    //   }
    // },
    getOccupationsDetail: function() {
      var that = this;
      this.api.getOccupationDetail({ id: that.occupationId }, function(data) {
        that.occupationDetail = data.result;
      });
    },
    getCourseDetail: function() {
      let postData = {};
      var that = this;
      // if(this.$route.params.dataSource=="edx"){
      postData.key = this.courseKey;
      // }else{
      //     postData.id=this.$route.params.key
      // }
      this.api.getCourseDetail(postData, function(data) {
        that.course = data.result;
      });
    }
  },
  activated(){
    var that = this;
      this.$store.state.selectMenu = 4;
      this.$store.state.mate.description = this.$i18n.t("message.Courses_desc");
      this.$store.state.mate.keywords = this.$i18n.t("message.Courses_keywords");
      this.$store.state.mate.title = this.$i18n.t("message.Browse Courses")+" - talent.gov.hk - "+that.$i18n.t("message.Default Page Title");
      if(this.$store.state.formData.headTabState4&&!this.$route.params.keyword){ 
        this.$store.state.formData.headTabState4 = false;
        this.aok = [] //清空原有数据
        new Promise((resolve,reject)=>{
          that.startRow = 0;
          
          that.$refs.browseC.isCef = false;
          that.$refs.browseC.isQr = false;
          that.$refs.browseC.isEdx = false;
          that.$refs.browseC.showExtra = false;
          that.dataSource = '';
          that.keyword = '';
          that.learningMode = '';
          that.areaOfStudy = '';
          that.grantingBody = '';
          that.courseQuickQuery = '';
          that.filterActive = {};
          that.isCef = '';
          if(that.$route.query.page){
            that.page = parseInt(that.$route.query.page);
            that.startRow = Math.ceil(that.page/5)-1
            var smallPaging = that.page%5==0?5:that.page%5; 
            that.changeSmallPaging(smallPaging)
          }
          that.$refs.browseC.keyword = '';
          that.getCourseList(); // 重新加载
          that.$refs.browseC.getAreaOfStudy();
          that.$refs.browseC.getGrantingBody();
          that.$refs.browseC.getLearningMode();
          that.$refs.browseC.getCourseLevelList();
         
          if(this.$refs.Pa != undefined){
            if(!that.$route.query.page){
              this.$refs.Pa.changePageOne();
            }
            
            this.$refs.Pa.closeSelecPagingList();
          }
          setTimeout(()=>{
             window.scrollTo(0,0);
          },200)
          resolve();
        }).then((data)=>{
              //  that.$refs.browseC.clearAllselect();
        })
      }else if(this.$route.params.keyword&&this.fromLouterName != 'coursesDetail'){
    
          that.$refs.browseC.isCef = false;
          that.$refs.browseC.isQr = false;
          that.$refs.browseC.isEdx = false;
          that.$refs.browseC.showExtra = false;
          that.$refs.browseC.courseLevel = '';
          that.$refs.browseC.dataSource = '';
          that.$refs.browseC.selectedAllAreaOfStudy = true;
          that.$refs.browseC.selectedAllLearningMode = true;
          that.$refs.browseC.selectAllGrantingBody = true;
          that.$refs.browseC.selectAllLevel = true;
          that.$refs.browseC.learningMode = '';
          that.$refs.browseC.areaOfStudy = '';
          that.$refs.browseC.grantingBody = '';
          that.$refs.browseC.isCef = '';
          that.dataSource = '';
          // that.keyword = '';
          that.learningMode = '';
          that.areaOfStudy = '';
          that.grantingBody = '';
          that.courseQuickQuery = '';
          that.filterActive = {};
          that.isCef = '';
          // that.$refs.browseC.keyword = '';
        
          that.$refs.browseC.getAreaOfStudy();
          that.$refs.browseC.getGrantingBody();
          that.$refs.browseC.getLearningMode();
          that.$refs.browseC.getCourseLevelList();
       
           that.$refs.browseC.searchEvent();
          if(this.$refs.Pa != undefined){
            if(!that.$route.query.page){
              this.$refs.Pa.changePageOne();
            }
            this.$refs.Pa.closeSelecPagingList();
          }
      }else if(this.$route.params.keyword&&this.fromLouterName == 'coursesDetail'){
       
          // that.keyword = '';
     
          // that.$refs.browseC.keyword = '';
        
      
       
          //  that.$refs.browseC.searchEvent();
       
      }
     
	    // setTimeout(()=>{
      //     window.scrollTo(0, that.scroll);
         
      //     window.addEventListener('scroll', that.handleScroll);
         
      // },200)
   	},
   	//deactivated 页面退出时关闭事件 防止其他页面出现问题
  deactivated(){
		// window.removeEventListener('scroll', this.handleScroll);
  },
    beforeRouteLeave(to, from, next){ 
        this.fromLouterName = to.name;
      
        if(to.name=='coursesDetail'){
          from.meta.isUseCache = true;
        }else{
          from.meta.isUseCache = false;
        }
        next()
    },
  mounted() {
    // EventBus.$emit('error', { errMsg: this.$i18n.t("message.developmentTip")})
    this.$store.state.selectMenu = 4;
    this.startRow = 0;
    this.courses = [];
    var that = this;
    setTimeout(function(){
      that.$store.state.mate.title = that.$i18n.t("message.Browse Courses")+" - talent.gov.hk - "+that.$i18n.t("message.Default Page Title");
      that.$store.state.mate.keywords = that.$i18n.t("message.Courses_keywords");
    })
    window.addEventListener('scroll', this.handleScroll);
    // if(this.$store.state.formData.coursesType){
    //      this.coursesType = this.$store.state.formData.coursesType;
    //      this.$store.state.formData.coursesType = 0;
    //      if(this.coursesType==1||this.coursesType==2){
    //         this.occupationId = this.$store.state.formData.occupationId;
    //         this.$store.state.formData.occupationId = "";
    //         this.getOccupationsDetail();
    //         this.getListAllByOccupation();
    //      }else if(this.coursesType==3||this.coursesType==4){
    //         this.courseKey = this.$store.state.formData.courseKey;
    //         this.$store.state.formData.courseKey = "";
    //         this.getCourseDetail();
    //         this.getAllDetailLinkCourse();
    //      }
    // }else{
    if(that.$route.query.page){
      that.page = parseInt(that.$route.query.page);
      that.startRow = Math.ceil(that.page/5)-1
      var smallPaging = that.page%5==0?5:that.page%5; 
      that.changeSmallPaging(smallPaging)
    }
    if (!this.$route.params.keyword) {
      this.getCourseList();
      // this.$refs.Pa.changePageNum();
    }
    // }
    // window.addEventListener("scroll", this.scrollEvent);
    // getJobPostingDetail:function(id){
    //     var that = this
    //     this.api.getJobPostingDetail({
    //         "id": id,
    //     }, function(data) {
    //        that.jobPostingDetail=data.result;
    //     })
    // }
  }
};
</script>